import transform from '@/services/devisCommandes/filters/devisCommandeServerTableDataTransformer';
import transformRenouvellement from '@/services/devisCommandes/filters/renouvellementServerTableDataTransformer';
import HTTP from '../HTTP';

const URL_BASE = 'gescom/Commande/';

export async function get(idCommande) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: idCommande } });
  return response;
}

export async function getAll(serverTabledata) {
  const inputServer = transform(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function getAllRenouvellement(data) {
  const inputServer = transformRenouvellement(data);
  const response = await HTTP.post(URL_BASE + 'PGetAllRenouvellementAsync', inputServer);
  return response;
}

export async function getAllTotauxMntRenouvellement(data) {
  const inputServer = transformRenouvellement(data);
  const response = await HTTP.post(URL_BASE + 'PGetTotauxMntRenouvellementAsync', inputServer);
  return response;
}

export async function echeancierGeneration(echeancier, montant, tiers) {
  const response = await HTTP.post(URL_BASE + 'PEcheancierGeneration', { echeancier, montant, tiers });
  return response;
}

export async function echeancierGenerationAll(echeanciers) {
  const response = await HTTP.post(URL_BASE + 'PEcheancierGenerationAll', echeanciers);
  return response;
}

export async function create(commande) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', commande);
  return response;
}

export async function update(commande) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', commande);
  return response;
}

export async function remove(idCommande) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id: idCommande } });
  return response;
}

export async function sansSuite(idCommande) {
  const response = await HTTP.post(URL_BASE + 'SansSuiteAsync', { id: idCommande });
  return response;
}

export async function generationFactureAcompte(param) {
  const response = await HTTP.post(URL_BASE + 'GenerationFactureAcompteAsync', param);
  return response;
}

export async function nonRenouvelee(params) {
  const response = await HTTP.post(URL_BASE + 'NonRenouveleeAsync', params);
  return response;
}

export async function retourEnAttente(id) {
  const response = await HTTP.post(URL_BASE + 'RetourEnAttenteAsync', { id: id });
  return response;
}

export async function renouvellementReconduction(id, isRenouvellementOrTacide) {
  const response = await HTTP.post(URL_BASE + 'RenouvellementReconductionAsync', { devisCommandeId: id, etatRenouvellement: isRenouvellementOrTacide });
  return response;
}

export async function cloture(id, dateCloture) {
  const response = await HTTP.post(URL_BASE + 'ClotureAsync',
    {
      id: id,
      dateCloture: dateCloture,
    });
  return response;
}

export async function generationCommandes(params) {
  const response = await HTTP.post(URL_BASE + 'GenerationCommandesAsync', params);
  return response;
}

export async function enCoursRenouvellement(param) {
  const response = await HTTP.post(URL_BASE + 'EnCoursRenouvellementAsync', param);
  return response;
}

export async function marquerRenouveleReconduit(params) {
  const response = await HTTP.post(URL_BASE + 'MarquerRenouveleReconduitAsync', params);
  return response;
}

export async function regenerationCommandeAchatVenteInterne(idCommande) {
  const response = await HTTP.post(URL_BASE + 'RegenerationCommandeAchatVenteInterneAsync', { id: idCommande });
  return response;
}

export async function reactiverCommande(id) {
  const response = await HTTP.post(URL_BASE + 'ReactiverCommandeAsync', { id: id });
  return response;
}

export async function commenter(payload) {
  const response = await HTTP.post(URL_BASE + 'CommenterAsync', payload);
  return response;
}

export async function indexation(payload) {
  const response = await HTTP.post(URL_BASE + 'IndexationAsync', payload);
  return response;
}

export async function annulationIndexation(payload) {
  const response = await HTTP.post(URL_BASE + 'AnnulationIndexationAsync', payload);
  return response;
}

export async function getZipPjOtAffichage(id) {
  const config = {
    responseType: 'blob',
  };
  const response = await HTTP.post(URL_BASE + 'PGetZipPiecesJointesLignesOtDaffichageAsync', { id: id }, config);
  return response;
}
